import React from 'react';
import { FaTimes } from "react-icons/fa";
import './pagetitle.css';

const PageTitle = ({ title, onClick, address, phone }) => {
  return (
    <div className='d-flex justify-content-between align-items-start p-3 title-bg'>
      <div className='d-flex flex-column text-white me-2'>
        {/* Title */}
        <div className='regular text-white fw-bold fs-5 mb-1'>
          {title}
        </div>

        {/* Address */}
        {address && (
          <div className='regular text-white-50 small mb-1' style={{ fontSize: '13px', color: 'rgba(255,255,255,0.85)' }}>
            {address}
          </div>
        )}

        {/* Phone Number */}
        {phone && (
          <div className='regular text-white-50 small' style={{ fontSize: '13px', color: 'rgba(255,255,255,0.85)' }}>
            Phone No: {phone}
          </div>
        )}
      </div>

      {/* Close Button */}
      <button 
        type="button" 
        onClick={onClick} 
        className='pagetitle-close-btn'
        aria-label="Close"
      >
        <FaTimes />
      </button>
    </div>
  );
}

export default PageTitle;
